import React, { useState, useEffect } from "react";
import { usersService } from "../../services";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../CustomDialog";
import { User } from "../../interfaces";
import { MultiSelect } from "primereact/multiselect";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../../config/awsParams";

interface ModalShareActifProps {
  actif: any;
  modalIsOpenPartage: boolean;
  closeModalPartage: () => void;
}
const ModalShareActif = ({
  actif,
  modalIsOpenPartage,
  closeModalPartage,
}: ModalShareActifProps) => {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState(null);
  const [members, setMembers] = useState([]);
  const [formData, setFormData] = useState({
    actif_id: "",
    members_ids: [],
  });
  const navigate = useNavigate();

  const handleSelectChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    if (selectedOptions.length !== 0) {
      setLoading(false);
      setFormData((prevFormData) => ({
        ...prevFormData,
        actif_id: actif.id,
      }));
      const selectedValues = selectedOptions.map((option) => option.value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        members_ids: selectedValues,
      }));
    }
    if (selectedOptions.length === 0) {
      setLoading(true);
    }
  };

  const onSubmit = async () => {
    try {
      const response = await usersService.AssigneUsersActif(formData);

      const selectedValues = selectedOptions.map((option) => option.value);

      setSelectedOptions([]);
      setData(response);
      closeModalPartage();
      navigate("/liste-actifs");
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  useEffect(() => {
    const fetchMembers = async (id) => {
      try {
        const response = await usersService.get_members_actif(id);
        setMembers(response);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };

    // Simulate data fetching
    const fetchUserAPI = async () => {
      try {
        const response = await usersService.getAll();
        const mappedOptions = response?.map((user) => ({
          value: user.id,
          label: (
            <div className="flex space-x-2">
              <img
                className="object-cover w-6 h-6 rounded-full"
                src={
                  user.photo_user
                    ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${user.photo_user}`
                    : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
                }
              />
              <h1 className="text-xs font-semibold text-gray-700 capitalize mt-1">
                {user.first_name + " " + user.last_name}
              </h1>
            </div>
          ),
        }));
        setOptions(mappedOptions);
        setUsers(response);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    fetchUserAPI();
    fetchMembers(actif?.id);
  }, []);

  return (
    <CustomDialog
      visible={modalIsOpenPartage}
      closeModalDialog={closeModalPartage}
      header="Partager actif"
    >
      <div className="w-full h-full ">
        <div className="p-6 space-y-6">
          <span className=" text-gray-500">
            Tous les membres de l'actif ont accès à tous les fichiers
          </span>
          <div className="flex  space-x-2">
            {/* <Select
              className="basic-multi-select w-full "
              classNamePrefix="select"
              options={options}
              isMulti
              value={selectedOptions}
              onChange={handleSelectChange}
            /> */}
            <MultiSelect
              className="my-3 border border-gray-300 text-gray-900 font-bold text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
              placeholder="Sélectionner membres..."
              options={options}
              value={selectedOptions}
              onChange={handleSelectChange}
              name="id"
              filter
            />
            <button
              onClick={() => onSubmit()}
              disabled={loading}
              className="text-white w-auto disabled:opacity-25 bg-gexpertise-100 hover:bg-gexpertise-200 font-normal rounded-md text-sm  px-1 py-1 text-center"
            >
              Envoyer
            </button>
          </div>

          <div
            id="alert-4"
            className="flex p-4 mb-4 text-yellow-800 rounded-lg bg-yellow-50 "
            role="alert"
          >
            <svg
              aria-hidden="true"
              className="flex-shrink-0 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
            <span className="sr-only">Info</span>
            <div className="ml-3 text-sm font-normal">
              N'oubliez pas de donner aux membres l'accès à vos fichiers
            </div>
            <button
              type="button"
              className="ml-auto -mx-1.5 -my-1.5 bg-yellow-50 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex h-8 w-8 "
              data-dismiss-target="#alert-4"
              aria-label="Close"
            >
              <span className="sr-only">Close</span>
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div>
            <span className="text-gray-500 font-semibold">
              Membres ({data?.members?.length})
            </span>
            <div className="overflow-y-auto">
              {members?.map((member) => (
                <button
                  key={member.id}
                  className="flex items-center w-full px-4 py-5 space-x-2 transition-colors duration-200  gap-x-2 hover:bg-gray-100 focus:outline-none"
                >
                  <img
                    className="object-cover w-10 h-10 rounded-full"
                    src={
                      member.photo_user
                        ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${member.photo_user}`
                        : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
                    }
                  />
                  <div className="text-left rtl:text-right">
                    <h1 className="text-md font-semibold text-gray-700 capitalize ">
                      {member.first_name + " " + member.last_name}
                    </h1>
                    <p className="text-sm text-gray-400 ">{member.email}</p>
                  </div>
                  <span className=" text-sm flex pl-10 text-gray-500">
                    {member.access_level}
                  </span>
                </button>
              ))}
            </div>
          </div>
          <div>
            <span className="text-gray-500 font-semibold">Lien à partager</span>
            <form>
              <div className="flex my-5 space-x-2">
                <input
                  type="text"
                  name="partage"
                  id="partage"
                  placeholder="https://www.sharemylink.com"
                  className=" w-full rounded-md border-0  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gexpertise-100 sm:text-lg sm:leading-6"
                />

                <button
                  type="submit"
                  className="text-gexpertise-200 w-20 bg-white hover:bg-gray-200  border  font-bold rounded-md text-sm p-2.5 text-center  "
                >
                  Copier
                </button>
                <button
                  type="submit"
                  className="bg-white hover:bg-gray-200  w-14 border   rounded-md  p-4 text-center  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="#9ca3af"
                  >
                    <path d="M6 12c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm9 0c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm9 0c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z" />
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalShareActif;
